import { render, staticRenderFns } from "./gameEvent2Config.vue?vue&type=template&id=5edfdd18&"
import script from "./gameEvent2Config.vue?vue&type=script&lang=js&"
export * from "./gameEvent2Config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edfdd18')) {
      api.createRecord('5edfdd18', component.options)
    } else {
      api.reload('5edfdd18', component.options)
    }
    module.hot.accept("./gameEvent2Config.vue?vue&type=template&id=5edfdd18&", function () {
      api.rerender('5edfdd18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameEvent2Config.vue"
export default component.exports